// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"e36ce307","470":"297ccb6d","601":"48d06dd6","787":"2e9aacd9","835":"ad58be50","952":"e98f3c2d"}[chunkId] + ".chunk.js";
};